import 'babel-polyfill'
import React from "react";
import { Form, Icon, Input, Button, Card, Modal } from "antd";
import { reactLocalStorage } from "reactjs-localstorage";
import "../styles/css/login.scss";
import { login, getLoginCode, loginCode } from "./api/categories";

// import Vconsole from 'vconsole'  // const vConsole = new Vconsole()
class UserLogin extends React.Component {
  constructor() {
    super();
    this.state = {
      isAdVisible: false,
      code: "",
      phone: "",
      modelShowY: false,
      TextY: '',
      login: false,
      loading: false,
      collapsed: false,
      loginInfo: {},
      uid: "",
      roomId: "",
      name: "",
      users: [],
      messages: [],
      localAudioEnabled: true,
      localVideoEnabled: true,
      screenSharingEnabled: false,
      vidFit: false,
      brush: false,
      isFullScreen: false,
      FieldsValue: {
        roomId: "",
        displayName: "",
        displayPassword: "",
      },
      roomForm: {
        username: reactLocalStorage.get('username') ? reactLocalStorage.get('username') : "",
        password: reactLocalStorage.get("password") ? reactLocalStorage.get("password") : "",
      },
      models: {
        Text: "",
        modelShow: true,
      },
      roomList: {
        roomId: "",
      },
    };

    this.settings = {
      selectedAudioDevice: "",
      selectedVideoDevice: "",
      resolution: "hd",
      bandwidth: 2048,
      codec: "H264",
    };
    // const vConsole = new Vconsole()

    let settings = reactLocalStorage.getObject("settings");
    if (settings.codec !== undefined) {
      this.settings = settings;
    }

    let logostate = this.getCookie("logostatelocal");
    console.log(logostate);
    if (logostate) {
      // window.location.href="https://alocal.xytechsz.com/#/RoomList"
    }
  }
  closeAd = () => {
    this.setState({ isAdVisible: false });
  };
  showAd = () => {
    this.setState({ isAdVisible: true });
  };

  hideAd = () => {
    this.setState({ isAdVisible: false });
  };

  ok = () => {
    // window.open("https://en.xytechsz.com/%E6%98%95%E6%98%B1%E7%A7%91%E6%8A%80%E7%97%85%E7%90%86%E5%8D%8F%E4%BD%9C%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E1.0.0.pdf", "_blank")
    this.setState({ isAdVisible: false });
  };

  componentDidMount = () => {
    this.clearSessionStorage();
    // Set a timer to show ad after 3 seconds
    this.adTimer = setTimeout(() => {
      this.setState({ isAdVisible: true });
    }, 1000); // 3000 milliseconds = 3 seconds
    // Other logic
    // Clear all cookies
    // this.removeAllCookies();

    // Clear all sessionStorage data
    // this.clearSessionStorage();

    // Other logic
    let params = this.getRequest();
    let roomId = "room1";
    let displayName = "";

    let localStorage = reactLocalStorage.getObject("loginInfo");

    if (localStorage) {
      roomId = localStorage.roomId;
      displayName = localStorage.displayName;
    }

    if (params && params.hasOwnProperty("room")) {
      roomId = params.room;
    }
    this.setState({
      FieldsValue: {
        roomId: roomId,
        displayName: displayName,
        displayPassword: "123456",
      },
    });
  };

  componentWillUnmount = () => {
    this.cleanup();
    // Clear the timer to prevent memory leaks
    clearTimeout(this.adTimer);
  };

  removeAllCookies = () => {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  };

  clearSessionStorage = () => {
    // sessionStorage.clear();
  };

  cleanup = async () => { };

  userLogin = async (username, password) => {
    const res = await login({
      name: username,
      password: password,
    });
    console.log(res);
    if (res.code == "200") {
      reactLocalStorage.set('username', username);
      reactLocalStorage.set('password', password);
      sessionStorage.setItem("username", res.data.userName);
      sessionStorage.setItem("userName", res.data.phone);
      sessionStorage.setItem("userId", res.data.id);
      sessionStorage.setItem("bigvideo", 1);
      sessionStorage.setItem("times", res.data.times);
      sessionStorage.setItem("activate", res.data.activate);
      sessionStorage.setItem("token", new Date().getTime());
      this.setCookie("logostatelocal", 1, 1);
      this.setCookie("yk", 0);
      this.props.history.push("/RoomList");
    } else {
      alert("Incorrect username or password");
    }
  };

  validatePhoneNumber = (phone) => {
    // Regular expression: starts with 1, followed by 10 digits
    const phoneRegex = /^1[3-9]\d{9}$/;
    return phoneRegex.test(phone);
  };

  getLoginCode = async (phone) => {
    if (this.validatePhoneNumber(phone)) {
      console.log("Phone number format is correct");
    } else {
      alert("Incorrect phone number");
    }
    try {
      // Use GET request, passing parameters
      const res = await getLoginCode({
        phone: phone,
      });

      console.log(res);
      if (res.code === "200") {

      } else {
        alert("Incorrect phone number");
      }
    } catch (error) {
      console.error("Request failed:", error);
      alert("Request failed, please try again later");
    }
  };

  loginCode = async (username, password) => {
    try {
      // Use GET request, passing parameters
      const res = await loginCode({
        name: username,
        password: password,
      });

      console.log(res);
      if (res.code === "200") {
        sessionStorage.setItem("username", res.data.userName);
        sessionStorage.setItem("userName", res.data.phone);
        sessionStorage.setItem("userId", res.data.id);
        sessionStorage.setItem("bigvideo", 1);
        sessionStorage.setItem("times", res.data.times);
        sessionStorage.setItem("activate", res.data.activate);
        sessionStorage.setItem("token", new Date().getTime());
        this.setCookie("logostatelocal", 1, 1);
        this.setCookie("yk", 0);
        this.props.history.push("/RoomList");
      } else {
        alert("Incorrect username or password");
      }
    } catch (error) {
      console.error("Request failed:", error);
      alert("Request failed, please try again later");
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.userLogin(
      this.state.roomForm.username,
      this.state.roomForm.password
    );
    // getCategoriesAsync;
    // this.props.history.push("/RoomList");
  };

  setCookie = (name, value, iDay) => {
    var oDate = new Date();

    oDate.setDate(oDate.getDate() + iDay);

    document.cookie = name + '=' + value + ';expires=' + oDate;
  };

  getCookie = (name) => {
    var arr = document.cookie.split('; ');
    var i = 0;
    for (i = 0; i < arr.length; i++) {
      var arr2 = arr[i].split('=');

      if (arr2[0] == name) {
        return arr2[1];
      }
    }
    return ''; // Return empty value if not found
  };

  removeCookie = (name) => {
    this.setCookie(name, 0, -1); // Set expiration date to yesterday, system will automatically delete it
  };

  getRequest() {
    let url = location.search;
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
      let str = url.substr(1);
      let strs = str.split("&");
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
      }
    }
    return theRequest;
  }

  inputChangeAdmin(e) {
    this.setState({
      roomForm: {
        username: e.target.value,
        password: this.state.roomForm.password,
      },
    });
  }

  inputChangePassword(e) {
    this.setState({
      roomForm: {
        username: this.state.roomForm.username,
        password: e.target.value,
      },
    });
  }

  handleOk = () => {
    setModalText('The modal will be closed after two seconds');
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
    }, 2000);
  };

  handleCancel = () => {
    console.log('Clicked cancel button');
    setOpen(false);
  };

  inputChangeSmsCode = (e) => {
    this.setState({ code: e.target.value });
  };

  inputChangePhoneNumber = (e) => {
    this.setState({ phone: e.target.value });
  };

  // Guest login
  inputChangeRoomName(e) {
    this.setState({
      roomList: {
        roomId: e.target.value,
      },
    });
  }

  jumpRegister = () => {
    console.log("ss");
    this.props.history.push("/Register");
  };

  handleForgotPassword = () => {
    console.log("ss");
    this.props.history.push("/ForgetPassword");
  };

  roomSubmit = (e) => {
    e.preventDefault();
    // sessionStorage.setItem('roomId',this.state.roomList.roomId );
    // sessionStorage.setItem('yk',1);
    // this.props.history.push("/Samples")
    this.props.history.push("/VideoPlayer");
  };

  render() {
    const { getFieldDecorator } = this.state;

    return (
      <div className="login-main">
        <div className="login-bg">
          <Form
            onSubmit={this.handleSubmit}
            className="login-form"
            style={{ padding: "46px 120px" }}
          >
            <h1 className="login-title">E-Phathology</h1>

            <Form.Item
              name="displayName"
              rules={[{ required: true, message: "Please enter your phone number" }]}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <div style={{ width: "120px" }}>Mobile:</div>
                <Input
                  value={this.state.roomForm.username}
                  onChange={(e) => this.inputChangeAdmin(e)}
                  prefix={<Icon type="team" className="login-input-icon" />}
                  placeholder="Please enter your Mobile"
                />
              </div>
            </Form.Item>

            <Form.Item
              name="displayPassword"
              rules={[{ required: true, message: "Please enter your password" }]}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <div style={{ width: "120px" }}>Password:</div>
                <Input
                  type="password"
                  value={this.state.roomForm.password}
                  onChange={(e) => this.inputChangePassword(e)}
                  prefix={<Icon type="contacts" className="login-input-icon" />}
                  placeholder="Please enter your password"
                />
              </div>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-join-button"
              >
                Log on
              </Button>
            </Form.Item>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
              <div>Recommended to use Google Chrome</div>
            </div>
          </Form>

          <Form
            onSubmit={this.roomSubmit}
            className="login-form"
            style={{ padding: "98px 120px", marginLeft: "10px" }}
          >
            <h1 className="login-title">Conference</h1>

            <Form.Item
              name="displayName"
              rules={[{ required: true, message: "Please enter room number" }]}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <div style={{ width: "60px" }}>Room:</div>
                <Input
                  onChange={(e) => this.inputChangeRoomName(e)}
                  prefix={<Icon type="team" className="login-input-icon" />}
                  placeholder="Please enter room"
                />
              </div>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-join-button"
              >
                Visitor
              </Button>
            </Form.Item>
          </Form>

         

          <Modal
            title="Title"
            open={this.state.models.modelShow}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <p>{this.state.models.Text}</p>
          </Modal>

        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '120px', color: "#1890ff" }}>
          <div>Copyright © Shenzhen Xinyu Technology Development (Shenzhen) Co., Ltd. | ICP No. 2022136163</div>
        </div>
        <div>
          {this.state.isAdVisible && (
            <div
              style={{
                position: 'fixed',
                top: 20,
                left: 20,
                width: 300,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                zIndex: 1000,
                pointerEvents: 'auto', // Ensure div internal interaction
              }}
            >
              <div style={{ padding: '10px' }}>
                <h1>Co-create Brilliance Ad Placeholder</h1>
                <button onClick={this.hideAd}>Close</button>
              </div>
            </div>
          )}

          {this.state.isAdVisible && (
            <div
              style={{
                position: 'fixed',
                bottom: 20,
                right: 20,
                width: 300,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                zIndex: 1000,
                pointerEvents: 'auto', // Ensure div internal interaction
              }}
            >
              <div style={{ padding: '10px' }}>
                <h1>Co-create Brilliance Ad Placeholder</h1>
                <button onClick={this.hideAd}>Close</button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default UserLogin;